import { render } from "./PriceList.vue?vue&type=template&id=2f0c173c&scoped=true"
import script from "./PriceList.vue?vue&type=script&lang=js"
export * from "./PriceList.vue?vue&type=script&lang=js"

import "./PriceList.vue?vue&type=style&index=0&id=2f0c173c&scoped=true&lang=css"
import "./PriceList.vue?vue&type=style&index=1&id=2f0c173c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f0c173c"]])

export default __exports__